
import React from "react";
import styles from "./styles/loader.module.scss";
const Loader = ({ size }) => {
  let dimension = size
    ? {
        width: `${1.5 * size}rem`,
        height: `${1.5 * size}rem`,
      }
    : { width: `1.5rem`, height: `1.5rem` };
  return <div className={styles.loader} style={dimension}></div>;
};


export default Loader